export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./resource.vue?vue&type=template&id=4046fac5&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/resource/resource.vue?vue&type=template&id=4046fac5&scoped=true&
// module id = null
// module chunks = 